export const stats = [
  { number: "35+", label: "Años de experiencia", suffix: "" },
  { number: "1,200+", label: "Proyectos exitosos", suffix: "" },
  { number: "350+", label: "Clientes satisfechos", suffix: "" },
  { number: "5", label: "Marcas premium aliadas", suffix: "" },
] as const;

export interface Service {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  image: string;
  icon: string;
  cta: string;
  video?: string;
  path?: string;
  bullets?: string[];
  listTitle?: string;
}

export const services: Service[] = [
  {
    id: "venta",
    title: "Venta de Equipos",
    subtitle: "Tecnología de punta con garantía real",
    description: "",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20air%20conditioning%20showroom%20with%20multiple%20AC%20units%20on%20display%2C%20clean%20white%20interior%2C%20warm%20ambient%20lighting%2C%20professional%20product%20photography%2C%20minimal%20background%2C%20neutral%20earth%20tones%20with%20subtle%20green%20accent%2C%20commercial%20equipment%20store&width=600&height=400&seq=service-venta-1&orientation=landscape",
    icon: "ri-shopping-cart-line",
    cta: "Cotizar equipo",
    path: "/servicios/venta-de-equipos",
    bullets: [
      "Sistemas de refrigerante variable VRF / DVM para micro y macro proyectos",
      "Equipos Inverter ecológicos (R32) amigables con el medio ambiente, de última generación que reducen tu consumo energético hasta en un 40%. Trabajamos con Samsung, LG, Midea, Mabe y Mirage. Garantía de fábrica incluida en todos los equipos.",
    ],
  },
  {
    id: "instalacion",
    title: "Instalación Profesional",
    subtitle: "Ingenieros certificados, no improvisadores",
    description:
      "Instalación ejecutada por ingenieros con 35 años de trayectoria. Cumplimos normas SST y entregamos certificado de instalación.",
    listTitle: "Diseño e instalación de micro y macro proyectos de:",
    bullets: [
      "Sistemas de climatización de refrigerante variable VRF / DVM.",
      "Sistemas uno a uno convencionales: MINISPLIT, CASSETTE, PISO TECHO, TIPO DUCTO, TIPO PAQUETE.",
      "Sistemas condensados por agua, con torre de enfriamiento.",
      "Sistemas de ventilación mecánica, de extracción de aire, para renovación de aire, control de humedad relativa con deshumidificadores de aire.",
      "Cuartos fríos, Refrigeración comercial.",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Professional%20HVAC%20technician%20installing%20modern%20air%20conditioning%20unit%20on%20building%20exterior%2C%20wearing%20safety%20gear%2C%20clean%20industrial%20setting%2C%20warm%20daylight%2C%20professional%20photography%2C%20documentary%20style%2C%20earth%20tones&width=600&height=400&seq=service-inst-1&orientation=landscape",
    video:
      "https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/eebc3daf-7066-4959-b091-e3019cf82a42_Tcnico_revisando_aire_acondicio_202609021054.mp4",
    icon: "ri-tools-line",
    cta: "Solicitar instalación",
  },
  {
    id: "mantenimiento",
    title: "Mantenimiento Preventivo",
    subtitle: "Evita averías que cuestan 5x más",
    description:
      "El 70% de las averías costosas se evitan con mantenimiento preventivo. Nuestras pólizas incluyen limpieza profunda, revisión de refrigerante y calibración de termostatos. Reduce tu factura de energía hasta un 30%.",
    image:
      "https://readdy.ai/api/search-image?query=HVAC%20maintenance%20technician%20cleaning%20air%20conditioning%20unit%20filters%2C%20close%20up%20professional%20hands%20working%20on%20equipment%2C%20warm%20workshop%20lighting%2C%20detailed%20mechanical%20photography%2C%20industrial%20maintenance%20scene%2C%20earth%20tones%20and%20warm%20lighting&width=600&height=400&seq=service-mant-1&orientation=landscape",
    icon: "ri-shield-check-line",
    cta: "Contratar mantenimiento",
  },
];

export const processSteps = [
  {
    step: 1,
    title: "Asesoría Gratuita",
    description:
      "Nuestros ingenieros evalúan tu espacio y necesidades sin costo. Te presentamos la solución más eficiente energéticamente.",
    icon: "ri-customer-service-2-line",
  },
  {
    step: 2,
    title: "Visita Técnica",
    description:
      "Inspeccionamos in situ las condiciones del espacio, medimos cargas térmicas y verificamos infraestructura disponible.",
    icon: "ri-map-pin-line",
  },
  {
    step: 3,
    title: "Diseño del Proyecto",
    description:
      "Elaboramos planos, especificaciones técnicas y presupuesto detallado. Aprobamos contigo antes de ejecutar.",
    icon: "ri-draft-line",
  },
  {
    step: 4,
    title: "Instalación o Mantenimiento",
    description:
      "Ejecutamos el trabajo con personal certificado, cumpliendo normas SST y estándares de calidad internacional.",
    icon: "ri-hammer-line",
  },
  {
    step: 5,
    title: "Pruebas y Capacitación",
    description:
      "Verificamos el funcionamiento óptimo del sistema y te capacitamos en su uso para maximizar eficiencia.",
    icon: "ri-check-double-line",
  },
  {
    step: 6,
    title: "Soporte y Garantía",
    description:
      "Acompañamiento postventa con garantía de 1 año en instalaciones. Soporte técnico disponible.",
    icon: "ri-shield-star-line",
  },
] as const;

export const whyUs = [
  {
    title: "35 años de experiencia real",
    description:
      "Nuestro gerente de proyectos ha liderado más de 1,200 instalaciones en hogares, comercios e industrias.",
    icon: "ri-medal-line",
  },
  {
    title: "Garantía de 1 año en instalaciones",
    description:
      "Cada instalación incluye garantía escrita de 12 meses. Si algo falla por nuestra ejecución, lo reparamos sin costo.",
    icon: "ri-shield-check-line",
  },
  {
    title: "Cumplimiento normas SST",
    description:
      "Todos nuestros técnicos están certificados en Seguridad y Salud en el Trabajo. Tu empresa está protegida.",
    icon: "ri-file-shield-line",
  },
  {
    title: "Ahorro energético garantizado",
    description:
      "Nuestros sistemas Inverter y VRF reducen el consumo eléctrico entre 30% y 40% comparado con equipos convencionales.",
    icon: "ri-flashlight-line",
  },
  {
    title: "Cobertura en toda Colombia",
    description:
      "Desde Bogotá hasta cualquier ciudad de Colombia. Trabajamos con empresas nacionales y proyectos regionales.",
    icon: "ri-map-2-line",
  },
  {
    title: "Soporte técnico",
    description:
      "Emergencias no esperan horario. Nuestra línea de soporte responde los 365 días del año para clientes con póliza.",
    icon: "ri-phone-line",
  },
] as const;

export const testimonials = [
  {
    name: "Laura Pérez",
    role: "Gerente de Operaciones - Hotel Bogotá",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Colombian%20business%20woman%20in%20her%2040s%2C%20warm%20smile%2C%20hotel%20manager%20uniform%2C%20neutral%20office%20background%2C%20soft%20natural%20lighting%2C%20corporate%20headshot%20style%2C%20warm%20earth%20tones&width=80&height=80&seq=testi-laura-1&orientation=squarish",
    rating: 5,
    text: "El servicio de SERIN ha sido excepcional. Nos ayudaron a instalar un sistema de climatización eficiente para todo el hotel, logrando un ambiente confortable para nuestros huéspedes y reduciendo significativamente el consumo eléctrico. ¡Altamente recomendados!",
  },
  {
    name: "Andrés Gutiérrez",
    role: "Propietario - Restaurante",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Colombian%20man%20in%20his%2050s%2C%20restaurant%20owner%2C%20warm%20friendly%20expression%2C%20casual%20business%20attire%2C%20neutral%20background%2C%20natural%20lighting%2C%20corporate%20headshot%2C%20warm%20tones&width=80&height=80&seq=testi-andres-1&orientation=squarish",
    rating: 5,
    text: "Nuestro restaurante necesitaba un sistema de extracción y ventilación eficiente, y SERIN nos brindó la mejor solución. Diseñaron un sistema adaptado a nuestras necesidades, asegurando un ambiente fresco y libre de humo en la cocina. Un equipo de expertos en toda regla.",
  },
  {
    name: "Carolina Mendoza",
    role: "Directora de Operaciones - Clínica",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Colombian%20woman%20in%20her%2030s%2C%20healthcare%20director%2C%20confident%20expression%2C%20white%20coat%20over%20business%20attire%2C%20clean%20medical%20office%20background%2C%20soft%20lighting%2C%20corporate%20headshot%2C%20neutral%20warm%20tones&width=80&height=80&seq=testi-carolina-1&orientation=squarish",
    rating: 5,
    text: "En una clínica, la calidad del aire es vital. SERIN instaló nuestro sistema de ventilación mecánica y filtros HEPA con precisión quirúrgica. Cumplieron los tiempos y el presupuesto. El confort de nuestros pacientes mejoró notablemente.",
  },
] as const;

export const brands = [
  {
    name: "Samsung",
    logo: "https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/a959756e-9bc9-4b7c-aa71-2026d7437ec5_compressed_1.webp",
  },
  {
    name: "LG",
    logo: "https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/45044b53-478e-4dd0-a46d-ed4c7703fa22_compressed_2.webp",
  },
  {
    name: "Midea",
    logo: "https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/14484f77-dd94-4908-a351-db2bece3cdd0_compressed_Anti-Pixelation-Image-Fix-1.webp",
  },
  {
    name: "Mabe",
    logo: "https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/5106040d-92d6-4f6a-b8b7-f953604d1fec_compressed_Anti-Pixelation-Image-Fix.webp",
  },
  {
    name: "Mirage",
    logo: "https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/cac9ed350034b49726faf4e32bc4b0ee.png",
  },
] as const;

export const serviceOptions = [
  "Venta de Equipos de Climatización",
  "Instalación de Aires Acondicionados",
  "Mantenimiento para Aires Acondicionados y Cuartos Fríos",
  "Ventilación Mecánica",
  "Asesoría Profesional con Ingenieros",
  "Filtración de Aire",
] as const;

export const heroImage =
  "https://readdy.ai/api/search-image?query=Modern%20commercial%20building%20exterior%20with%20HVAC%20air%20conditioning%20units%20and%20ventilation%20systems%20on%20rooftop%2C%20deep%20blue%20and%20cyan%20color%20palette%2C%20cool%20blue%20atmospheric%20lighting%2C%20navy%20blue%20sky%2C%20cyan%20glowing%20accents%2C%20professional%20architectural%20photography%2C%20blue%20tones%20and%20cool%20ambient%20light%2C%20industrial%20elegance&width=1600&height=900&seq=hero-serin-main&orientation=landscape&nocache=true";

export const aboutImage =
  "https://readdy.ai/api/search-image?query=Professional%20engineering%20team%20in%20safety%20helmets%20reviewing%20HVAC%20blueprints%20on%20modern%20construction%20site%2C%20warm%20natural%20lighting%2C%20collaborative%20work%20scene%2C%20documentary%20photography%20style%2C%20earth%20tones%20and%20industrial%20setting%2C%20professional%20team%20portrait&width=800&height=600&seq=about-serin-1&orientation=landscape";

export const aboutImage2 =
  "https://readdy.ai/api/search-image?query=Modern%20industrial%20HVAC%20mechanical%20ventilation%20and%20refrigeration%20systems%20with%20exposed%20ductwork%20and%20cooling%20units%20on%20a%20clean%20rooftop%2C%20warm%20natural%20lighting%2C%20sustainable%20energy%20efficient%20building%20technology%2C%20earth%20tones%20with%20subtle%20green%20eco%20accents%2C%20professional%20technical%20architectural%20photography%2C%20harmonious%20composition&width=800&height=600&seq=about-serin-2&orientation=landscape";

export const aboutVideo =
  "https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/2d524dcb-2f2c-4807-a897-5a863e382442_Crear_video_corporativo_industri_202609012313.mp4";